<section id="modal-solicitation">
  <div class="modal-solicitation-container">
    <div class="row" *ngIf="selectedProduct">
      <div class="modal-solicitation-content">
        <div class="go-back">
          <div class="close-container">
            <!--<button (click)="setShowProducts(this.selectedCategory); openModal('products'); form.reset();"
                class="close-button before-button">
                <i class="fas fa-arrow-left"></i>
              </button>-->
            <button class="close-button before-button" (click)="closeDialog(true)">
              <i class="fas fa-arrow-left"></i>
            </button>

            <button class="close-button" (click)="closeDialog(false)">
              <i class="fas fa-times"></i>
            </button>
          </div>

          <div class="d-flex modal-solicitation--title">
            <div class="modal-solicitation-title">
              <img
                style="border-radius: 50%; margin-right: 10px"
                src="{{selectedProduct.href}}"
                height="50px"
                width="50px"
                alt=""
                appImgFallback
              />
              <h3>{{ selectedProduct.name }}</h3>
            </div>
          </div>
        </div>
        <br />
        <div class="modal-solicitation-card-body mt-2">
          <div class="itens-center">
            <form [formGroup]="form">
              <div
                *ngIf="responsiveMobile; else formDesktop;"
                style="
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  gap: 0.5rem;
                  color: #3a3b3c;
                  padding: 1px;
                "
              >
                <i class="fas fa-chevron-left" *ngIf="responsiveMobile && etapa_1"></i>
                <button
                  [ngStyle]="etapa_1 && {'background-color': 'var(--color-store)'} || {'background-color': '#3A3B3C'}"
                  style="
                    width: 1.5rem;
                    height: 1.5rem;
                    border-radius: 50%;
                    font-weight: bold;
                    color: white;
                    border: none;
                  "
                  (click)="toggleStep()"
                  class=""
                >
                  1
                </button>
                <button
                  [ngStyle]="etapa_2 && {'background-color': 'var(--color-store)'} || {'background-color': '#3A3B3C'}"
                  style="
                    width: 1.5rem;
                    height: 1.5rem;
                    border-radius: 50%;
                    font-weight: bold;
                    color: white;
                    border: none;
                  "
                  (click)="toggleStep()"
                  class=""
                >
                  2
                </button>
                <i class="fas fa-chevron-right" *ngIf="responsiveMobile && etapa_2"></i>
              </div>

              <div class="form-row" style="margin-top: 1rem" *ngIf="responsiveMobile && etapa_1">
                <div class="col-sm-6">
                  <span *ngIf="typeSelect === 'CPF' || selectedProduct.type === 'CPF'">
                    <input
                      [brmasker]="{ person: true }"
                      [ngClass]="cssError('document')"
                      class="form-control"
                      formControlName="document"
                      placeholder="Documento CPF"
                      maxlength="14"
                      #cnpj
                    />
                  </span>
                  <span *ngIf="typeSelect === 'CNPJ' || selectedProduct.type === 'CNPJ'">
                    <input
                      [brmasker]="{ person: true }"
                      [ngClass]="cssError('document')"
                      class="form-control"
                      formControlName="document"
                      placeholder="Documento CNPJ"
                      minlength="17"
                      #cnpj
                    />
                  </span>
                  <span *ngIf="typeSelect === 'ALL' && selectedProduct.type === 'ALL'">
                    <input
                      [brmasker]="{ person: true }"
                      [ngClass]="cssError('document')"
                      class="form-control"
                      formControlName="document"
                      placeholder="Documento CNPJ e CPF"
                      #cnpj
                    />
                  </span>
                  <button
                    *ngIf="formProduct.document && formProduct.document.length > 17"
                    style="
                      width: 25px;
                      height: 25px;
                      padding: 1%;
                      position: absolute;
                      top: 5%;
                      right: 10px;
                      border-radius: 50%;
                    "
                    class="btn btn-primary fa fa-search d-inline-flex"
                    (click)="getCNPJ()"
                  ></button>
                  <div *ngIf="hasError('document')" class="invalid-feedback">
                    <span *ngIf="hasError('document', 'required')">O campo é obrigatório</span>
                    <span *ngIf="hasError('document', 'IsCPForCNPJ')">CNPJ ou CPF inválido</span>
                  </div>
                </div>

                <div class="col-sm-6">
                  <input
                    [ngClass]="cssError('name')"
                    class="form-control"
                    formControlName="name"
                    placeholder="Razão Social/Nome Completo"
                  />
                  <div *ngIf="hasError('name')" class="invalid-feedback">O campo é obrigatório</div>
                </div>
                <div class="col-sm-6">
                  <input
                    [ngClass]="cssError('phone')"
                    [textMask]="{ mask: this.phoneMask }"
                    class="form-control"
                    formControlName="phone"
                    placeholder="Telefone"
                  />

                  <div *ngIf="hasError('phone')" class="invalid-feedback">O campo é obrigatório</div>
                </div>
                <div class="col-sm-6">
                  <input
                    [ngClass]="cssError('whatsapp_phone')"
                    [textMask]="{ mask: this.phoneMask }"
                    class="form-control"
                    formControlName="whatsapp_phone"
                    placeholder="Whatsapp"
                  />

                  <div *ngIf="hasError('whatsapp_phone')" class="invalid-feedback">O campo é obrigatório</div>
                </div>
              </div>
              <ng-container *ngIf="responsiveMobile && etapa_1">
                <div class="d-flex justify-content-center align-items-center mt-3 btn-solicitation-container">
                  <button
                    (click)="toggleStep()"
                    class="btn font-weight-bold btn-lg btn-solicitation"
                    style="
                      background-color: var(--color-store);
                      border-radius: 30px;
                      font-size: 1.2rem;
                      font-family: Montserrat, sans-serif;
                      font-weight: 400 !important;
                      margin: auto;
                      display: block;
                    "
                  >
                    Continuar
                  </button>
                </div>
              </ng-container>

              <br />

              <div class="form-row" formGroupName="address" *ngIf="responsiveMobile && etapa_2">
                <div style="display: flex; gap: 0.5rem">
                  <div class="col-sm-6" style="position: relative; padding: 0">
                    <input
                      #cep
                      [brmasker]="{mask: '00000-000', type:'num'}"
                      [ngClass]="cssError('address.zipcode')"
                      class="form-control"
                      formControlName="zipcode"
                      maxlength="9"
                      placeholder="CEP"
                    />
                    <button
                      style="
                        width: 25px;
                        height: 25px;
                        padding: 1%;
                        position: absolute;
                        top: 20%;
                        right: 10px;
                        border-radius: 50%;
                      "
                      class="btn btn-primary fa fa-search d-inline-flex"
                      *ngIf="cep.value.length > 7"
                      (click)="getCep()"
                    ></button>
                    <div *ngIf="hasError('address.zipcode')" class="invalid-feedback">
                      <div *ngIf="hasError('address.zipcode', 'required')">Campo obrigatório</div>
                      <div *ngIf="hasError('address.zipcode', 'minLength')">O CEP precisa ter 8 dígitos</div>
                      <div *ngIf="hasError('address.zipcode', 'cepInvalid')">CEP inválido</div>
                    </div>
                  </div>

                  <div class="col-sm-6" style="padding: 0">
                    <input
                      [brmasker]="{mask: '000000000', type:'num'}"
                      [ngClass]="cssError('address.number')"
                      class="form-control"
                      formControlName="number"
                      placeholder="Numero"
                      type="text"
                    />

                    <div *ngIf="hasError('address.number')" class="invalid-feedback">O campo é obrigatório</div>
                  </div>
                </div>

                <div class="col-sm-3">
                  <input
                    [ngClass]="cssError('address.street')"
                    class="form-control"
                    formControlName="street"
                    placeholder="Logradouro"
                  />
                  <div *ngIf="hasError('address.street')" class="invalid-feedback">O campo é obrigatório</div>
                </div>

                <div class="col-sm-4">
                  <input
                    [ngClass]="cssError('complement')"
                    class="form-control"
                    formControlName="complement"
                    placeholder="Complemento"
                    type="text"
                  />
                </div>
                <div class="col-sm-4">
                  <input
                    [ngClass]="cssError('address.neighborhood')"
                    class="form-control"
                    formControlName="neighborhood"
                    placeholder="Bairro"
                    type="text"
                  />

                  <div *ngIf="hasError('address.neighborhood')" class="invalid-feedback">O campo é obrigatório</div>
                </div>
              </div>

              <div class="form-row" *ngIf="responsiveMobile && etapa_2">
                <div style="display: flex; margin-bottom: 0.5rem; gap: 0.5rem">
                  <div formGroupName="address">
                    <input
                      style="margin-bottom: 0"
                      [ngClass]="cssError('address.city')"
                      class="form-control"
                      formControlName="city"
                      placeholder="Cidade"
                      type="text"
                    />

                    <div *ngIf="hasError('address.city')" class="invalid-feedback">O campo é obrigatório</div>
                  </div>

                  <div formGroupName="address">
                    <input
                      style="margin-bottom: 0"
                      [ngClass]="cssError('address.state')"
                      class="form-control"
                      formControlName="state"
                      placeholder="Estado"
                      type="text"
                    />

                    <div *ngIf="hasError('address.state')" class="invalid-feedback">O campo é obrigatório</div>
                  </div>
                </div>

                <div class="col-sm-4">
                  <input
                    [ngClass]="cssError('responsible')"
                    class="form-control"
                    formControlName="responsible"
                    placeholder="Responsável"
                    type="text"
                  />

                  <div *ngIf="hasError('responsible')" class="invalid-feedback">
                    <span *ngIf="hasError('responsible', 'required')">O campo é obrigatório</span>
                  </div>
                </div>
                <div class="col-sm-4">
                  <input
                    [ngClass]="cssError('email')"
                    class="form-control"
                    formControlName="email"
                    placeholder="E-mail"
                    type="text"
                  />

                  <div *ngIf="hasError('email')" class="invalid-feedback">
                    <span *ngIf="hasError('email', 'required')">O campo é obrigatório</span>
                    <span *ngIf="hasError('email', 'email')">E-mail inválido</span>
                    <span *ngIf="hasError('email', 'NotExists')">E-mail ja cadastrado</span>
                  </div>
                </div>
              </div>
            </form>
            <div class="form-group mb-2 text-center">
              <input type="checkbox" [(ngModel)]="accept_terms" name="accept_terms" />
              <span class="text-center">
                Declaro que li e concordo com a
                <a href="https://teddydigital.io/politicas/" target="_blank">política de privacidade de dados</a>
                e com o
                <a href="https://teddydigital.io/termo-autorizacao-scr-e-consentimento-de-dados" target="_blank">
                  termo de autorização de scr e consentimento de dados
                </a>
                do Banco Central do Brasil, para receber a melhor proposta possível.
              </span>
            </div>

            <div *ngIf="responsiveMobile && etapa_2">
              <div class="d-flex justify-content-center align-items-center mt-3 btn-solicitation-container">
                <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
                <button
                  (click)="send()"
                  class="btn font-weight-bold btn-lg btn-solicitation"
                  style="
                    background-color: var(--color-store);
                    border-radius: 30px;
                    font-size: 1.2rem;
                    font-family: Montserrat, sans-serif;
                    font-weight: 400 !important;
                  "
                >
                  Solicitar Agora
                </button>
              </div>
            </div>
            <!-- Form Desktop -->
            <ng-template #formDesktop>
              <form [formGroup]="form">
                <div class="form-row formDesktop">
                  <div class="col-sm-6">
                    <span *ngIf="typeSelect === 'CPF' || selectedProduct.type === 'CPF'">
                      <input
                        [brmasker]="{ person: true }"
                        [ngClass]="cssError('document')"
                        class="form-control"
                        formControlName="document"
                        placeholder="Documento CPF"
                        maxlength="14"
                        #cnpj
                      />
                    </span>
                    <span *ngIf="typeSelect === 'CNPJ' || selectedProduct.type === 'CNPJ'">
                      <input
                        [brmasker]="{ person: true }"
                        [ngClass]="cssError('document')"
                        class="form-control"
                        formControlName="document"
                        placeholder="Documento CNPJ"
                        minlength="17"
                        #cnpj
                      />
                    </span>
                    <span *ngIf="typeSelect === 'ALL' && selectedProduct.type === 'ALL'">
                      <input
                        [brmasker]="{ person: true }"
                        [ngClass]="cssError('document')"
                        class="form-control"
                        formControlName="document"
                        placeholder="Documento CNPJ e CPF"
                        #cnpj
                      />
                    </span>
                    <button
                      *ngIf="formProduct.document && formProduct.document.length > 17"
                      style="
                        width: 25px;
                        height: 25px;
                        padding: 1%;
                        position: absolute;
                        top: 5%;
                        right: 10px;
                        border-radius: 50%;
                      "
                      class="btn btn-primary fa fa-search d-inline-flex"
                      (click)="getCNPJ()"
                    ></button>
                    <div *ngIf="hasError('document')" class="invalid-feedback">
                      <span *ngIf="hasError('document', 'required')">O campo é obrigatório</span>
                      <span *ngIf="hasError('document', 'IsCPForCNPJ')">CNPJ ou CPF inválido</span>
                    </div>
                  </div>

                  <div class="col-sm-6">
                    <input
                      [ngClass]="cssError('name')"
                      class="form-control"
                      formControlName="name"
                      placeholder="Razão Social/Nome Completo"
                    />
                    <div *ngIf="hasError('name')" class="invalid-feedback">O campo é obrigatório</div>
                  </div>
                  <div class="col-sm-6">
                    <input
                      [ngClass]="cssError('phone')"
                      [textMask]="{ mask: this.phoneMask }"
                      class="form-control"
                      formControlName="phone"
                      placeholder="Telefone"
                    />

                    <div *ngIf="hasError('phone')" class="invalid-feedback">O campo é obrigatório</div>
                  </div>
                  <div class="col-sm-6">
                    <input
                      [ngClass]="cssError('whatsapp_phone')"
                      [textMask]="{ mask: this.phoneMask }"
                      class="form-control"
                      formControlName="whatsapp_phone"
                      placeholder="Whatsapp"
                    />

                    <div *ngIf="hasError('whatsapp_phone')" class="invalid-feedback">O campo é obrigatório</div>
                  </div>
                </div>
                <br />
                <div class="form-row formDesktop" formGroupName="address">
                  <div class="col-sm-3">
                    <input
                      #cep
                      [brmasker]="{mask: '00000-000', type:'num'}"
                      [ngClass]="cssError('address.zipcode')"
                      class="form-control"
                      formControlName="zipcode"
                      maxlength="9"
                      placeholder="CEP"
                    />
                    <button
                      style="
                        width: 25px;
                        height: 25px;
                        padding: 1%;
                        position: absolute;
                        top: 0;
                        right: 10px;
                        border-radius: 50%;
                      "
                      class="btn btn-primary fa fa-search d-inline-flex"
                      *ngIf="cep.value.length > 7"
                      (click)="getCep()"
                    ></button>
                    <div *ngIf="hasError('address.zipcode')" class="invalid-feedback">
                      <div *ngIf="hasError('address.zipcode', 'required')">Campo obrigatório</div>
                      <div *ngIf="hasError('address.zipcode', 'minLength')">O CEP precisa ter 8 dígitos</div>
                      <div *ngIf="hasError('address.zipcode', 'cepInvalid')">CEP inválido</div>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <input
                      [ngClass]="cssError('name')"
                      class="form-control"
                      formControlName="street"
                      placeholder="Logradouro"
                    />
                    <div *ngIf="hasError('street')" class="invalid-feedback">O campo é obrigatório</div>
                  </div>
                  <div class="col-sm-3">
                    <input
                      [brmasker]="{mask: '000000000', type:'num'}"
                      [ngClass]="cssError('address.number')"
                      class="form-control"
                      formControlName="number"
                      placeholder="Numero"
                      type="text"
                    />

                    <div *ngIf="hasError('address.number')" class="invalid-feedback">O campo é obrigatório</div>
                  </div>

                  <div class="col-sm-4">
                    <input
                      [ngClass]="cssError('complement')"
                      class="form-control"
                      formControlName="complement"
                      placeholder="Complemento"
                      type="text"
                    />
                  </div>
                  <div class="col-sm-4">
                    <input
                      [ngClass]="cssError('address.neighborhood')"
                      class="form-control"
                      formControlName="neighborhood"
                      placeholder="Bairro"
                      type="text"
                    />

                    <div *ngIf="hasError('address.neighborhood')" class="invalid-feedback">O campo é obrigatório</div>
                  </div>
                  <div class="col-sm-4">
                    <input
                      [ngClass]="cssError('address.city')"
                      class="form-control"
                      formControlName="city"
                      placeholder="Cidade"
                      type="text"
                    />

                    <div *ngIf="hasError('address.city')" class="invalid-feedback">O campo é obrigatório</div>
                  </div>
                </div>
                <!--  -->
                <div class="form-row formDesktop">
                  <div class="col-sm-4" formGroupName="address">
                    <input
                      [ngClass]="cssError('address.state')"
                      class="form-control"
                      formControlName="state"
                      placeholder="Estado"
                      type="text"
                    />

                    <div *ngIf="hasError('address.state')" class="invalid-feedback">O campo é obrigatório</div>
                  </div>
                  <div class="col-sm-4">
                    <input
                      [ngClass]="cssError('responsible')"
                      class="form-control"
                      formControlName="responsible"
                      placeholder="Responsável"
                      type="text"
                    />

                    <div *ngIf="hasError('responsible')" class="invalid-feedback">
                      <span *ngIf="hasError('responsible', 'required')">O campo é obrigatório</span>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <input
                      [ngClass]="cssError('email')"
                      class="form-control"
                      formControlName="email"
                      placeholder="E-mail"
                      type="text"
                    />

                    <div *ngIf="hasError('email')" class="invalid-feedback">
                      <span *ngIf="hasError('email', 'required')">O campo é obrigatório</span>
                      <span *ngIf="hasError('email', 'email')">E-mail inválido</span>
                      <span *ngIf="hasError('email', 'NotExists')">E-mail ja cadastrado</span>
                    </div>
                  </div>
                </div>
              </form>
              <div class="d-flex justify-content-center align-items-center mt-5 mb-1 btn-solicitation-container">
                <ngx-spinner type="ball-scale-multiple"></ngx-spinner>
                <button
                  (click)="send()"
                  class="btn font-weight-bold btn-lg btn-solicitation"
                  style="
                    background-color: var(--color-store);
                    padding: 0.8rem 4rem;
                    border-radius: 2.5rem;
                    font-size: 1.5rem;
                    font-family: Montserrat, sans-serif;
                    font-weight: 500 !important;
                  "
                >
                  Solicitar Agora
                </button>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
